module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapsible-pane",
    class: {
      expanded: _vm.expanded
    }
  }, [_c('div', {
    staticClass: "collapsible-header",
    on: {
      "click": function($event) {
        _vm.$emit('toggle', _vm.identifier)
      }
    }
  }, [_c('p', {
    staticClass: "header-title"
  }, [_vm._v(_vm._s(_vm.headerTitle))]), _vm._v(" "), _c('span', {
    staticClass: "collapsible-header__arrow"
  }, [_c('svg', {
    attrs: {
      "width": "18px",
      "height": "18px"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "9",
      "cy": "9",
      "r": "8",
      "fill": "black"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5 7 l4 4 l4 -4"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "collapsible-contents"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c76f5b86","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collapsiblePane.vue
// module id = 617
// module chunks = 0